(function () {
  'use strict'

  require('dynamic-bind-html')
  require('angular-base64')

  require('./scss/card.scss')
  require('./scss/card-kiosk.scss')
  require('./component/scss/app-image-promotion.scss')

  const MODULE_NAME = 'thismoment.card.core'
  const templateUrl = require('./tpl/card.html')
  const avatarDefault = require('../common/assets/img/default-user.png')
  const imageDefault = require('../common/assets/img/placeholder.png')

  require('angular')
    .module(MODULE_NAME, [
      'dynamicBindHtml', // ಠ_ಠ
      'base64',
      require('angular-moment'),
      require('../analytics'),
      require('../common/component/video'),
      require('../common/component/video-facebook'),
      require('../common/component/video-youtube'),
      require('../common/directive/err-src'),
      require('../content'),
      require('../expandedContent'),
      require('./component/app-html'),
      require('./component/app-mva-embed'),
      require('./component/app-textAPlaylist'),
      require('./component/app-vcardDynamic'),
      require('./component/app-vcardImagePromo'),
      require('./component/app-eventDynamic'),
      require('./component/description'),
      require('./component/sharing')
    ])
  // TODO: Only bind content ID to component controllers, use Content service to get necessary content data.
    .component('thismomentCard', {
      require: ['^?ngSwitch'],
      bindings: {
        item: '<',
        analytics: '<',
        kioskMode: '<',
        carouselMode: '<',
        playlistId: '<',
        options: '<'
      },
      templateUrl: templateUrl,
      controller: cardController
    })

  cardController.$inject = ['$injector', '$element', '$base64', 'SdkConfig', 'analyticsSDK', 'ExpandedContent']
  function cardController ($injector, $element, $base64, SdkConfig, analyticsSDK, ExpandedContent) {
    const vm = this
    var isMobile = SdkConfig.get('is_mobile')
    var className
    var isDocument
    var isImage
    var isPdf
    var isText
    var isTwitterTextOnly
    var isVideo
    var sourceName
    var typeName

    vm.imageDefault = imageDefault
    vm.avatarDefault = avatarDefault

    vm.$onInit = cardInit

    function cardInit () {
      const item = vm.item

      vm.analyticsProps = angular.merge({}, vm.analytics, analyticsSDK.mapContentProps(vm.item))
      vm.ccmtContentId = vm.item.id

      if (!vm.options) {
        vm.options = {}
      }
      vm.options.playlistId = vm.playlistId

      // callable functions
      vm.expand = imageExpand
      vm.trackEvent = analyticsSDK.setupEventTracking(vm.analyticsProps)

      // Firing tracking event immediately on init prevents apps from
      // having to handle it themselves.
      vm.trackEvent('Content Viewed', {'event trigger': 'loaded playlist'})

      /** ********* Determine HOW is it displayed START ***********/
      vm.styles = {
        card: {
          background: vm.options.cardBG ? vm.options.cardBG : null,
          height: vm.options.cardHeight ? vm.options.cardHeight + 'px' : null,
          maxHeight: vm.options.cardHeight ? vm.options.cardHeight + 'px' : null,
          width: vm.options.width ? vm.options.width + 'px' : null,
          maxWidth: vm.options.maxWidth ? vm.options.maxWidth + 'px' : null
        },
        main: {
          borderTop: vm.carouselMode ? '' : '1px solid #eee'
        },
        title: {},
        descriptionStyles: {},
        date: {},
        source: {},
        icon: {}
      }
      vm.classes = {
        card: {
          'kiosk-mode': vm.kioskMode
        }
      }

      if (Object.prototype.hasOwnProperty.call(vm.options, 'card_border_shape')) {
        vm.classes.card.rounded = (vm.options.card_border_shape === 'rounded')
      }
      if (Object.prototype.hasOwnProperty.call(vm.options, 'card_background_color')) {
        vm.styles.descriptionStyles['background-color'] = vm.options.card_background_color
        vm.styles.main['background-color'] = vm.options.card_background_color
      }
      if (Object.prototype.hasOwnProperty.call(vm.options, 'card_border_color')) {
        vm.styles.card['border-color'] = vm.options.card_border_color
      }
      if (Object.prototype.hasOwnProperty.call(vm.options, 'card_title_font_color')) {
        vm.styles.title.color = vm.options.card_title_font_color
      }
      if (Object.prototype.hasOwnProperty.call(vm.options, 'card_description_font_color')) {
        vm.styles.descriptionStyles.color = vm.options.card_description_font_color
      }
      if (Object.prototype.hasOwnProperty.call(vm.options, 'card_description_link_font_color')) {
        item.description = item.description.replace(/<a href/g, '<a style="color:' + vm.options.card_description_link_font_color + ';" href')
      }
      if (Object.prototype.hasOwnProperty.call(vm.options, 'card_date_font_color')) {
        vm.styles.date.color = vm.options.card_date_font_color
      }
      if (Object.prototype.hasOwnProperty.call(vm.options, 'card_source_font_color')) {
        vm.styles.source.color = vm.options.card_source_font_color
      }
      if (Object.prototype.hasOwnProperty.call(vm.options, 'card_icon_color')) {
        vm.styles.icon.color = vm.options.card_icon_color
      }

      sourceName = item.source.source_name
      vm.cardType = sourceName
      vm.classes.card[sourceName] = (sourceName)

      className = item.class_name
      vm.classes.card[className] = (className)
      typeName = item.type_name
      vm.classes.card[typeName] = (typeName)

      if (item.extended) {
        for (let [key, value] of Object.entries(item.extended)) {
          if (key.endsWith('_class')) {
            vm.classes.card[value.trim().toLowerCase().replace(/ /g, '-')] = true
          }
        }
      }

      if (item.metadata) {
        for (let [key, value] of Object.entries(item.metadata)) {
          if (key.endsWith('_class')) {
            vm.classes.card[value[0].trim().toLowerCase().replace(/ /g, '-')] = true
          }
        }
      }
      /** ********* Determine HOW is it displayed END ***********/

      /** ********* Determine WHAT is displayed START ***********/
      var cardBools = [
        'card_source_display',
        'card_source_display',
        'card_date_display',
        'card_description_display',
        'card_media_display',
        'card_share_display',
        'card_title_display'
      ]

      angular.forEach(cardBools, function (value) {
        if (!Object.prototype.hasOwnProperty.call(vm.options, value)) {
          vm.options[value] = true
        }
      })

      // apps handle themselves.
      if (className === 'app') {
        if (typeName === 'html') {
          vm.isHtml = true
          return
        }
        if (typeName === 'mva-embed') {
          vm.isMvaEmbed = true
          return
        }
        if (typeName === 'text-a-playlist') {
          vm.isTextPlaylist = true
          return
        }
        if (typeName === 'vcard-dynamic') {
          vm.isVcardDynamic = true
          return
        }
        if (typeName === 'vcard-image-promo') {
          vm.isVcardImagePromo = true
          return
        }
        if (typeName === 'vcard-static') {
          vm.isVcardStatic = true
          return
        }
        if (typeName === 'event-dynamic') {
          vm.isEventDynamic = true
          return
        }
      }

      // default template values
      vm.allowHtml = !item.is_ugc
      vm.altText = (item.alt_text) ? item.alt_text : ''
      vm.analyticsTrigger = 'Content source viewed'
      vm.ariaLabel = item.title || item.description_ptf || item.alt_text
      vm.ariaDescribedBy = ((item.title) ? 'title' : (item.description) ? 'description' : '') + '-' + vm.ccmtContentId
      vm.author = item.source.author
      vm.avatar = item.source.avatar_url || item.source.favicon_url
      vm.avatarAltText = 'An avatar for ' + sourceName + ' user ' + vm.author
      vm.contentId = item.id
      vm.description = (item.is_ugc) ? item.description_ptf.replace(/(<br \/>\s*)+$/g, '') : item.description.replace(/(<br \/>\s*)+$/g, '')
      vm.sourceLinkAriaLabel = 'View the original ' + sourceName + ' content at ' + item.source.post_url
      vm.sourceSize = item.source.size
      vm.sourceUrl = item.source.post_url
      vm.title = item.title
      vm.username = '@' + item.source.username
      vm.username_url = item.source.username_url
      vm.displaySubmitter = false

      // this hideous mess is a result of the nasty metadata backend
      if (angular.isObject(item.metadata) &&
          'date_public' in item.metadata &&
          angular.isArray(item.metadata.date_public) &&
          item.metadata.date_public.length > 0 &&
          angular.isString(item.metadata.date_public[0]) &&
          item.metadata.date_public[0].length > 0) {
        const dateOverride = new Date(item.metadata.date_public[0])
        vm.timestamp = dateOverride.getTime() / 1000
      } else if (item.extended instanceof Object && 'date_public' in item.extended) {
        const dateOverride = new Date(item.extended.date_public)
        vm.timestamp = dateOverride.getTime() / 1000
      }

      if (className === 'text') {
        vm.imageSrc = null
        vm.timestamp = item.added_timestamp
      } else {
        // use the large if we don't have widths available; if we have the widths, use large only if it is greater than 350px wide
        vm.imageSrc = (isNaN(item.images.large.width) || item.images.large.width === null) ? item.images.large.url : (item.images.large.width > 500) ? item.images.large.url : item.images.original.url
      }

      /*
      OK, this is ugly... I get it. But it's way easier to maintain
      when it's like this than when everything's done in one huge
      logical clusterfuck. Believe me, I'm not thrilled with it, either.

      Display parameters that can't be true for a given card type are
      omitted for brevity and default values are overridden below where
      necessary.

      If you can make it prettier, by all means, be my guest. -NS
      */
      switch (sourceName) {
        case 'youtube':
          vm.ytId = item.source.origin_id
          vm.ytUrl = item.videos.large.url
          vm.ytImg = item.images.large.url

          vm.author = item.source.username
          vm.username = null

          vm.displayAuthor = (vm.author)
          vm.displayAvatar = (vm.avatar)
          vm.displayDescription = (!vm.kioskMode && item.description)
          vm.displayImage = (!isMobile)
          vm.displayImageAriaLabel = 'Play this YouTube video'
          vm.displayLinkIcon = true
          vm.displayTitle = (!vm.kioskMode && item.title)
          vm.displayVideoOverlay = (!isMobile && !vm.kioskMode)
          vm.displayYoutube = (isMobile)
          break

        case 'facebook':
          isImage = (className === 'image')
          isText = (className === 'text')
          isVideo = (className === 'video')

          vm.displayAuthor = (vm.author)
          vm.displayDateAdded = !vm.kioskMode
          vm.displayDescription = (item.description && !vm.kioskMode)
          vm.displayImage = vm.imageSrc && ((isVideo && !isMobile) || isImage)
          vm.displayImageAriaLabel = 'View this facebook post at full size'
          vm.displayLinkIcon = true
          vm.displayTitle = (item.title && !vm.kioskMode)
          vm.displayFacebookVideo = (isMobile && isVideo)
          vm.displayVideoOverlay = (isVideo && (!isMobile && !vm.kioskMode))
          break

        case 'instagram':
          isImage = (className === 'image')
          isVideo = (className === 'video')
          vm.displayAuthor = (vm.username)
          vm.displayAvatar = (vm.avatar)
          vm.displayDateAdded = true
          vm.displayDescription = ((item.description && item.description.length && item.description.trim().length) && !vm.kioskMode)
          vm.displayImage = vm.imageSrc && ((isVideo && !isMobile) || isImage)
          vm.displayImageAriaLabel = 'View this instagram image at full size'
          vm.displayLinkIcon = true
          vm.displayTitle = (item.title && !vm.kioskMode)
          vm.displayVideo = (isVideo && isMobile)
          vm.displayVideoOverlay = (isVideo && (!isMobile && !vm.kioskMode))
          break

        case 'linkedin':
          isImage = (className === 'image')
          isText = (className === 'text')

          vm.username = null
          vm.displayAuthor = vm.kioskMode ? false : (vm.author)
          vm.displayAvatar = vm.kioskMode ? false : (vm.avatar)
          vm.displayDateAdded = true
          vm.displayDescription = (!vm.kioskMode && item.description)
          vm.displayImage = vm.imageSrc && ((isVideo && !isMobile) || isImage)
          vm.displayLinkIcon = true
          vm.displayTitle = (!vm.kioskMode && item.title)
          break

        case 'publishthis':
          vm.author = item.source.username
          vm.username = null

          vm.displayAuthor = (vm.author)
          vm.displayAvatar = (vm.avatar)
          vm.displayDateAdded = true
          vm.displayDescription = (!vm.kioskMode && item.description)
          vm.displayImage = (vm.imageSrc)
          vm.displayImageAriaLabel = 'View full article'
          vm.displayLinkIcon = true
          vm.displayTitle = (!vm.kioskMode && item.title)
          break

        case 'thismoment':
        case 'thismoment-app':
          switch (className) {
            case 'text':
              isText = true
              if (vm.options.card_user_display) {
                if (!angular.isDefined(vm.item.extended[vm.options.card_user_firstname_key])) {
                  vm.item.extended[vm.options.card_user_firstname_key] = ''
                }
                if (!angular.isDefined(vm.item.extended[vm.options.card_user_lastname_key])) {
                  vm.item.extended[vm.options.card_user_lastname_key] = ''
                }
                vm.author = vm.item.extended[vm.options.card_user_firstname_key] + ' ' + vm.item.extended[vm.options.card_user_lastname_key]
                vm.username = ''
              }
              vm.classes.title = {
                'text-center': vm.kioskMode
              }
              break

            case 'app':
              vm.analyticsTrigger = 'clicked promo'
              vm.imageSrc = item.images.large.url
              vm.sourceUrl = SdkConfig.get('content_cloud_url') + '/api/export/v1/download-media?resource=' + $base64.encode(item.images.original.url)
              vm.imagePromoTarget = item.app.target

              // if spark we append a user uuid to the link for 3rd party tracking
              if (SdkConfig.get('solution_type') === 'spark' && SdkConfig.get('track_rep_links') && item.app.url.length > 0) {
                const querySlug = (item.app.url.includes('?')) ? '&' : '?'
                vm.imagePromoLink = item.app.url + querySlug + 'TMUSERID=' + SdkConfig.get('track_rep_id')
              } else {
                vm.imagePromoLink = item.app.url
              }

              vm.displayImagePromo = (vm.imageSrc)
              vm.displayImageAriaLabel = (vm.imagePromoLink) ? 'Go to ' + vm.imagePromoLink : 'View this image'

              vm.classes.imagePromo = {
                'no-link': !vm.imagePromoLink
              }
              vm.classes.title = {
                'text-center': vm.kioskMode
              }

              break

            case 'image':
              vm.sourceUrl = SdkConfig.get('content_cloud_url') + '/api/export/v1/download-media?resource=' + $base64.encode(item.images.original.url)
              isImage = true
              vm.altText = ((vm.altText) ? vm.altText + ' ' : '') + 'View this image at full size'

              if (angular.isObject(item.app) && 'url' in item.app && item.app.url !== '') {
                vm.analyticsTrigger = 'clicked promo'
                vm.imagePromoTarget = '_blank'
                vm.imagePromoLink = item.app.url
                vm.displayImagePromo = (vm.imageSrc)
              }

              if (vm.options.card_user_display) {
                if (!angular.isDefined(vm.item.extended[vm.options.card_user_firstname_key])) {
                  vm.item.extended[vm.options.card_user_firstname_key] = ''
                }
                if (!angular.isDefined(vm.item.extended[vm.options.card_user_lastname_key])) {
                  vm.item.extended[vm.options.card_user_lastname_key] = ''
                }
                vm.author = vm.item.extended[vm.options.card_user_firstname_key] + ' ' + vm.item.extended[vm.options.card_user_lastname_key]
                vm.username = ''
              }
              break

            case 'video':
              isVideo = true
              vm.sourceUrl = SdkConfig.get('content_cloud_url') + '/api/export/v1/download-media?resource=' + $base64.encode(item.videos.original.url)
              vm.displayImageAriaLabel = 'Play this video'
              if (vm.options.card_user_display) {
                if (!angular.isDefined(vm.item.extended[vm.options.card_user_firstname_key])) {
                  vm.item.extended[vm.options.card_user_firstname_key] = ''
                }
                if (!angular.isDefined(vm.item.extended[vm.options.card_user_lastname_key])) {
                  vm.item.extended[vm.options.card_user_lastname_key] = ''
                }
                vm.author = vm.item.extended[vm.options.card_user_firstname_key] + ' ' + vm.item.extended[vm.options.card_user_lastname_key]
                vm.username = ''
              }
              break

            case 'document':
              isDocument = true
              vm.sourceUrl = SdkConfig.get('content_cloud_url') + '/api/export/v1/download-media?resource=' + $base64.encode(item.source.post_url)
              vm.analyticsTrigger = 'downloaded/viewed file'
              vm.username = ''
              vm.displayImageAriaLabel = 'Open expanded version of this document'

              // Set classes, avatar, and author based on filetype
              switch (getFileExt()) {
                case 'xls':
                case 'xlsx':
                  vm.classes.card.excel = true
                  vm.avatar = require('../common/assets/img/icn-file-xls.png')
                  vm.author = 'Microsoft Excel'
                  break

                case 'ppt':
                case 'pptx':
                  vm.classes.card.presentation = true
                  vm.avatar = require('../common/assets/img/icn-file-ppt.png')
                  vm.author = 'Microsoft PowerPoint'
                  break

                case 'doc':
                case 'docx':
                  vm.classes.card.doc = true
                  vm.avatar = require('../common/assets/img/icn-file-doc.png')
                  vm.author = 'Microsoft Word'
                  break

                case 'pdf':
                  vm.classes.card.pdf = true
                  vm.avatar = require('../common/assets/img/icn-file-pdf.png')
                  vm.author = 'Adobe PDF'
                  isPdf = true
                  break
              }
              break
          }

          if ($injector.has('GlowConfig')) {
            var GlowConfig = $injector.get('GlowConfig')
          }

          vm.displayAuthor = (vm.author)
          vm.displayAvatar = (vm.avatar)
          vm.displayDateAdded = (!vm.kioskMode && isDocument)
          vm.displayDescription = isText || (!vm.kioskMode && item.description)
          vm.displayFileSize = (isDocument)
          vm.displayImage = vm.imageSrc && !vm.displayImagePromo && (isPdf || isImage || (isVideo && !isMobile))
          vm.displayLinkedTitle = (isDocument && vm.title)
          vm.displayLinkIcon = (vm.options.card_media_download && !vm.kioskMode)
          vm.displayTitle = vm.title && (vm.displayImagePromo || isText || (!vm.kioskMode && !isDocument))
          vm.displayVideo = (isMobile && isVideo)
          vm.displayVideoOverlay = ((!isMobile && !vm.kioskMode) && isVideo)
          vm.favicon = angular.isDefined(GlowConfig) && GlowConfig.get('favicon') && GlowConfig.get('favicon') !== '' ? GlowConfig.get('favicon') : false
          vm.displayFavicon = vm.favicon && vm.favicon !== '' && vm.kioskMode
          break

        case 'twitter':
          isImage = (className === 'image')
          isText = (className === 'text')
          isVideo = (className === 'video')
          isTwitterTextOnly = vm.kioskMode && item.source.source_name === 'twitter' && item.class_name === 'text'

          vm.displayAuthor = vm.kioskMode ? false : (vm.author)
          vm.displayAvatar = vm.kioskMode ? false : (vm.avatar)
          vm.displayDateAdded = true
          vm.displayDescription = (!vm.kioskMode && item.description)
          vm.displayImage = vm.imageSrc && ((isVideo && !isMobile) || isImage)
          vm.displayLinkIcon = true
          vm.displayTitle = (!vm.kioskMode && item.title)
          vm.displayTwitterKiosk = (vm.kioskMode && isText && item.description)
          vm.displayVideo = (isVideo && isMobile)
          vm.displayVideoOverlay = (isVideo && !isMobile && !vm.kioskMode)
          break

        default:
          vm.displayDescription = true
          vm.displayTitle = item.title
          vm.displaySubmitter = vm.kioskMode && item.extended.name_public
          break
      }

      // overrides from `card_options`
      vm.displayAuthor = isTwitterTextOnly ? true : (vm.options.card_source_display && vm.displayAuthor)
      vm.displayAvatar = isTwitterTextOnly ? true : (vm.options.card_source_display && vm.displayAvatar)
      vm.displayCart = vm.options.card_cart_display
      vm.displayVote = ('card_vote_display' in vm.options) ? vm.options.card_vote_display.contestActive : false
      vm.displayTopDateAdded = vm.options.dateTop
      vm.displayDateAdded = !vm.displayTopDateAdded && (vm.carouselMode || (vm.options.card_date_display && className !== 'app'))
      vm.displayDescription = (vm.options.card_description_display && vm.displayDescription)
      vm.displayMedia = vm.options.card_media_display
      vm.displayShare = (!vm.kioskMode && vm.options.card_share_display && className !== 'app')
      vm.displayTitle = (vm.options.card_title_display && vm.displayTitle)
      vm.displayHeader = vm.displayTitle || vm.displayLinkedTitle
      vm.linkOut = item.extended ? {link: item.extended.link_public, label: item.extended.label_public, color: vm.options.card_description_link_font_color} : false

      // final component logic
      vm.displayMeta = vm.displayAvatar || vm.displayAuthor
      vm.displayKioskMeta = (vm.displayAvatar || vm.displayAuthor) && (vm.kioskMode && isText && item.description)
      vm.displayFooter = vm.displayMeta || vm.displayShare
      vm.displayMain = vm.kioskMode || vm.displayLinkIcon || vm.displayHeader || vm.displayDescription || vm.displayDateAdded || vm.displayFileSize || vm.displayFooter || vm.displayCart || vm.displayShare
      vm.displayMedia = vm.displayMedia && (vm.displayImagePromo || vm.displayImage || vm.displayVideoOverlay || vm.displayTwitterKiosk || vm.displayYoutube || vm.displayFacebookVideo || vm.displayVideo)

      vm.classes.card['media-only'] = (vm.displayMedia && !vm.displayMain && !vm.displayFooter)

      function getFileExt () {
        var extArry = item.source.post_url.split('/')
        var fileExt = extArry[extArry.length - 1].split('.')

        return fileExt[fileExt.length - 1].toLowerCase()
      }

      function imageExpand () {
        var canExpand = false
        if (vm.options.layout === 'carousel') {
          if (vm.options.overlay_click) {
            canExpand = true
          }
        } else if (!isMobile) {
          canExpand = true
        }

        if (canExpand) {
          ExpandedContent.open(item, vm.options, null, () => {
            $element[0].focus()
          })
        }
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/card/card.js